import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e947fdec: FaireBrandEntity = {
  token: "b_e947fdec",
  type: "brand",
  name: "No Tox Life",
  avatarUrl:
    "https://cdn.faire.com/fastly/dc90f181c764978390ac85e7a48b9f9a237dcb135dc094897af9c73486526e94.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/42cd65362f26ff56de99ed699a35cb4ea4529cf6b12f5d455ed0171e594d065b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/dc90f181c764978390ac85e7a48b9f9a237dcb135dc094897af9c73486526e94.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/42cd65362f26ff56de99ed699a35cb4ea4529cf6b12f5d455ed0171e594d065b.jpeg",
  location: "Austin, TX, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 433,
  isTopShop: true,
  isInsider: true,
  description:
    "No Tox Life® is a mother-daughter team creating sustainable products for a cleaner home and body. All products are 100% vegan, and we ship using biodegradable and compostable packaging. We manufacture bath, body and home cleaning products in our solar-powered facility in North America. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:12.825Z",
    importedBy: "entity-db-cli",
  },
};
